import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import classes from './ChipButton.module.scss';
export const ChipButton = /*#__PURE__*/ forwardRef(function TextButton(props, ref) {
    const { className, suffixIcon, children, highlight, disabled, variant, testId } = props, rest = _object_without_properties(props, [
        "className",
        "suffixIcon",
        "children",
        "highlight",
        "disabled",
        "variant",
        "testId"
    ]);
    return /*#__PURE__*/ _jsxs("button", _object_spread_props(_object_spread({
        type: "button",
        ref: ref,
        disabled: disabled,
        className: cn(classes.root, className, {
            [classes.highlight]: highlight,
            [classes.fullWidth]: variant === 'fullWidth'
        }),
        "data-testid": testId
    }, rest), {
        children: [
            children,
            suffixIcon ? /*#__PURE__*/ _jsx("div", {
                className: classes.suffixIcon,
                children: suffixIcon
            }) : null
        ]
    }));
});
